import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import React, { Component } from 'react';

class VacationRow extends Component {
    render() {
        return (
            <TableContainer component={Paper}>
                <Table size="small" aria-label="a dense table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Sorszám</TableCell>
                            <TableCell>Munkavállaló</TableCell>
                            <TableCell>Napok száma</TableCell>
                            <TableCell>Kezdő dátum</TableCell>
                            <TableCell>Vég dátum</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow key="new">
                            <TableCell> {this.props.row.publicId}</TableCell>
                            <TableCell>{this.props.row.employeeName}</TableCell>
                            <TableCell>{this.props.row.days}</TableCell>
                            <TableCell>{this.props.row.startDate}</TableCell>
                            <TableCell>{this.props.row.endDate}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        )
    }
}
export default VacationRow;